import script from "./Mpu6050Graph.vue?vue&type=script&setup=true&lang=js"
export * from "./Mpu6050Graph.vue?vue&type=script&setup=true&lang=js"

import "./Mpu6050Graph.vue?vue&type=style&index=0&id=65deeee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65deeee2"]])

export default __exports__